import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";

import { VehicleCard } from "@app/components";
import { Strings } from "@app/constants";
import { PATH_DASHBOARD } from "@app/routes/paths";
import { useDispatch } from "react-redux";
import { filterCars } from "@app/modules/product-list-page/slice";
import { useRequestState } from "@app/hooks";
import { selectFilterCarsState } from "@app/modules/product-list-page/selector";

const priceRanges = [
  { label: "Under ₹100K", min: 0, max: 100000 },
  { label: "₹100K - ₹300K", min: 100000, max: 300000 },
  { label: "₹300K - ₹500K", min: 300000, max: 500000 },
  { label: "₹500K - ₹1M", min: 500000, max: 1000000 },
  { label: "₹1M+", min: 1000000, max: null },
];

const BrowseByPrice = () => {
  const theme = useTheme();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const { min, max } = priceRanges[selectedIndex];
    dispatch(filterCars({ min: min, max: max }));
  }, [dispatch, selectedIndex]);

  const { data: vehicleData } = useRequestState({
    stateSelector: selectFilterCarsState,
  });

  return (
    <Stack
      width="100%"
      bgcolor={theme.palette.primary.main}
      justifyContent="start"
      alignItems="start"
      py={5}
      px={{ xs: 1, md: 4 }}
    >
      <Typography variant="h3" color="white" mb={3}>
        {Strings.home.browseByPrice}
      </Typography>

      <Stack
        direction="row"
        gap={4}
        alignItems="center"
        mb={4}
        sx={{
          overflowX: "scroll",
          width: "100%",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {priceRanges?.map((range, index) => {
          const isSelected = index === selectedIndex;
          return (
            <Typography
              key={index}
              fontSize={18}
              fontWeight={600}
              sx={{
                cursor: "pointer",
                flexShrink: 0,
                borderBottom: isSelected
                  ? `3px solid ${theme.palette.common.white}`
                  : "none",
                color: isSelected
                  ? theme.palette.common.white
                  : theme.palette.grey[200],
                pb: 0.5,
              }}
              onClick={() => setSelectedIndex(index)}
            >
              {range.label}
            </Typography>
          );
        })}
      </Stack>

      <Stack
        direction="row"
        gap={3}
        sx={{
          width: "100%",
          overflowX: "auto",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        <Box
          sx={{
            overflowX: "auto",
            width: "100%",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Stack direction="row" gap={2} sx={{ minWidth: "max-content" }}>
            {vehicleData?.data?.length > 0 ? (
              vehicleData?.data?.map((vehicle: any) => (
                <VehicleCard
                  key={vehicle.id}
                  vehicle={vehicle}
                  selectedCardId={null}
                  onSelect={() => {}}
                  onViewDetails={() =>
                    navigate(`${PATH_DASHBOARD.productDetail}/${vehicle.id}`)
                  }
                />
              ))
            ) : (
              <Typography color={theme.palette.common.white}>
                {Strings.home.noVehiclesInThisRange}
              </Typography>
            )}
          </Stack>
        </Box>
      </Stack>
    </Stack>
  );
};

export default BrowseByPrice;
